import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css/navigation';
import { GlobalContext } from '../global/GlobalProvider';
import config from '../config';
import useSocket from '../global/Websoket.js';
import { Link, useNavigate, useLocation } from 'react-router';
import GloblePopup from '../common/GloblePopup';
import rip from "../assets/ripple_svg3.svg";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import ReactDOM from "react-dom";
import BackPricesBoxPerticular from './BackPricesBoxPerticular.jsx';
import LayPricesBoxPerticular from './LayPricesBoxPerticular.jsx';
import AviatorIcon from '../assets/AviatorIcon.jsx';
import { useTranslation } from 'react-i18next';

function BetList() {
    const { t, i18n } = useTranslation();
    const { isActiveSport, setActiveSport, exchangeData, setExchangeData,setLoginPop,loggedIn,stackArray,openSuccessPopup, openErrorPopup, setAlertMsg  } = useContext(GlobalContext);
    const [matchdatas, setMatchData] = useState();
    const { isConnected, receivedToken, sendMessage, receivedExchMinMax,receivedExchange } = useSocket();
    let countIntervalId = null;
    const [betOnProcess, setBetOnProcess] = useState(false);
    const [isBetSlipOpen, setIsBetSlipOpen] = useState(false);
    const [matchOdd, setMatchOdd] = useState();
    const [subActive, setSubActive] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    let subscribeChannels = useRef([]);
    const wsRef = useRef(null);
    let heartbeatInterval;
    const [activeMenu, setActiveMenu] = useState("");
    const [allMinMax, setAllMinMax] = useState([]);
    useEffect(() => {
    // setAllMinMax(receivedMinMax.minmaxdata);
    // console.log(receivedExchMinMax,"receivedMinMax.minmaxdatareceivedMinMax.minmaxdata");
        setAllMinMax(receivedExchMinMax.minmaxdata);
    }, [receivedExchMinMax])


    const isAdminSuspended = (id) => {
        if (id) {
            if (allMinMax && allMinMax.length > 0) {
                return !allMinMax.find(item => item.marketId.toString() == id.toString())?.resumesuspendstatus;
             }else{
                return true;
             }
        }else{
            return true;
        }
    }

    useEffect(() => {
        setActiveMenu(location.pathname);
    }, [location.pathname]);

    useEffect(()=>{},[isActiveSport])


    useEffect(()=>{
        setMatchData(receivedExchange);
        // console.log(receivedExchange,"receivedExchangereceivedExchange");
    },[receivedExchange])

    useEffect(() => {
        if (matchdatas) {
            unsubscribeAll();
            startWebSocket();

            const interval = setInterval(() => {
                sendMessage("exchangedata", {type:isActiveSport,userId:sessionStorage.getItem('userId')});
            }, 10000); // 10 seconds

            return () => clearInterval(interval);
        }
    }, [matchdatas]);

    const [isCashOut, setCashOut] = useState(false);
    let isOneClicked = sessionStorage.getItem('isOneClicked')
    let oneClickValue
    if(isOneClicked == 'true'){
        oneClickValue = sessionStorage.getItem('oneClickAmount')
    }

    useEffect(()=>{
        if (isConnected) {
            if (matchdatas) {
                const formattedArray = matchdatas?.game[0]?.matchData?.flatMap(match =>
                    match.matchodd.map(odd => ({
                        eventId: match.match.eventId,
                        marketId: odd.marketId
                    }))
                );

                sendMessage("getexchmarketminmaxdata", {exchdata:formattedArray});
                const interval = setInterval(() => {
                    sendMessage("getexchmarketminmaxdata", {exchdata:formattedArray});
                }, 10000); // 10 seconds

                return () => clearInterval(interval);
            }
        }
    },[isConnected,matchdatas])

    useEffect(() => {
        setMatchData();
        fetchData(isActiveSport,"time");
    }, [isActiveSport]);

       const publicKeyPEM = `-----BEGIN PUBLIC KEY-----
       MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKik5c/NUnfRBlOR6fgoSwG5YMEgclwe
       BBcPrHR452svxh9lPPNUr8stKqglGU40+ilIzXlsKlZ1sMKh4w6+O6MCAwEAAQ==
       -----END PUBLIC KEY-----`;

    // Generate AES key
    const generateAESKey = () => {
        return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex); // 16-byte key
    };

    // Encrypt with AES
    const encryptWithAES = (text, key) => {
        return CryptoJS.AES.encrypt(text, key).toString();
    };

    // Encrypt AES Key with RSA
    const encryptAESKeyWithRSA = (aesKey) => {
           return new Promise((resolve, reject) => {
               const encryptor = new JSEncrypt();
               encryptor.setPublicKey(publicKeyPEM);
               const encryptedKey = encryptor.encrypt(aesKey);

               if (encryptedKey) {
                   resolve(encryptedKey);
               } else {
                   reject("RSA Encryption failed!");
               }
           });
    };

    // Main function
    const encryptLargeMessage = async (message) => {
           try {
               const aesKey = generateAESKey(); // Step 1: Generate AES Key
               const encryptedMessage = encryptWithAES(message, aesKey); // Step 2: Encrypt Message

               // Step 3: Encrypt AES Key with RSA (using await)
               const encryptedAESKey = await encryptAESKeyWithRSA(aesKey);

               return {
                   encryptedMessage,
                   encryptedAESKey
               };
           } catch (error) {
               console.error("Encryption failed:", error);
           }
    };


    useEffect(() => {
             const encryptData = async () => {
                 let final = {};
                 if (receivedToken.token) {
                     console.log(receivedToken.token, "receivedTokenreceivedTokenreceivedToken");
                     let user = JSON.parse(sessionStorage.getItem('userinfo'));
                     let string = `${user._id}_${receivedToken.token}_${user.userName}`;
                     // Encrypt data
                     const enc = await encryptLargeMessage(string);
                     let msg = `${enc.encryptedAESKey}_token_${enc.encryptedMessage}`
                     let aaa = isOneClicked === "true" ? config.DATA : betsData
                     if (!isCashOut) {
                         if (isOneClicked === "true") {
                             aaa.stake = oneClickValue
                         }

                         final = {
                             ...aaa,    // If there's any existing data, retain it
                             msg: msg , // Add the new token
                         };
                     }else{
                         let asd = config.DATA
                         final = {
                             ...asd,    // If there's any existing data, retain it
                             msg: msg , // Add the new token
                         };
                     }

                     try {
                         // Replace 'your-token' with your actual token
                         const myHeaders = new Headers();
                         myHeaders.append("Content-Type", "application/json");
                         myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
                         console.log("request :::::: ", final)
                         const requestOptions = {
                             method: "POST",
                             headers: myHeaders,
                             redirect: "follow",
                             body: JSON.stringify(final)
                           };

                           fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/bets/placeBet_world`, requestOptions)
                           .then(async (response) => {
                             if (response.ok) {
                                 let result = await response.json();
                                //  sendBetList();
                                 openSuccessPopup();
                                 setBetOnProcess(false);
                                 clearInterval(countIntervalId);
                                 setAlertMsg(result.msg);
                                 handleResetBtn();
                                 setIsBetSlipOpen(false);
                                 config.DATA = {}
                                //  SendBookDetails_MB();
                                //  setCashOut(false);
                             } else{
                                 let errorResult = await response.json(); // Parse the JSON error response
                                //  sendBetList();
                                setIsBetSlipOpen(false);
                                 openErrorPopup();
                                 setAlertMsg(errorResult.message);
                                 setBetOnProcess(false);
                                 clearInterval(countIntervalId);
                                 config.DATA = {};
                                 handleResetBtn();
                                //  setCashOut(false);
                                //  SendBookDetails_MB();
                             }

                           })
                           .catch(async (error) => {
                            //  sendBetList();
                            //  SendBookDetails_MB();
                            //  setCashOut(false);
                             setBetOnProcess(false)
                             setIsBetSlipOpen(false);
                             clearInterval(countIntervalId);
                             config.DATA = {};
                             handleResetBtn();
                             console.log(error);
                            //  SendBookDetails_MB();
                           });

                     } catch (error) {
                        //  sendBetList();
                        //  SendBookDetails_MB();
                         setBetOnProcess(false)
                         setIsBetSlipOpen(false);
                         clearInterval(countIntervalId);
                        //  setCashOut(false);
                         handleResetBtn();
                         console.error('Error fetching API data:', error);
                     }
                 }
             };
             encryptData();
    }, [receivedToken])

    const uniqueCountriesFirst = (data) =>{
        return data && data.game?.some(game => game?.matchData?.length > 0)
        ? [...new Set(data.game.flatMap(game => game.matchData.map(item => item.match.country)))]
        : [];
    }
    const [stack, setStack] = useState([]);
    useEffect(() => {
        try{
            setStack(JSON.parse(stackArray));
        }catch(err){
            setStack(stackArray)
        }
    }, [stackArray]);

    const handlePlceBets = () => {
        clearInterval(countIntervalId);
        setBetOnProcess(true);
        let user = JSON.parse(sessionStorage.getItem('userinfo'));
        sendMessage("createToken",{userName:user.userName});
     }

    const handleClear = () => {
        handleResetBtn();
        setBetsData((prev) => ({
          ...prev,
          stake: "0", // Setting stake to '0'
        }));
      };

    const addValue = (item) => {
        // updateBook(betsData.stake,Number(item)+Number(betsData.stake))
        setBetsData(prev => ({
            ...prev,
            stake: (parseFloat(prev.stake) + Number(item))
        }))
     }


    const [betsData,setBetsData] = useState({
          eventId: '',
          marketId: '',
          stake: 0,
          betType: '',
          selectionName: '',
          competitionName:'',
          marketName: '',
          odds: '',
          rate: '',
          marketData:{},
          isFancy:''
    });

    const handleIncrementOdds = (event) => {
        let newOdds =(parseFloat(betsData.odds || "0") + 0.01).toFixed(2)
        setBetsData(prevState => ({
            ...prevState,
            odds: newOdds
        }));
     };

     const handleDecrementOdds = (event) => {
        let newOdds =(parseFloat(betsData.odds || "0") - 0.01).toFixed(2)
        setBetsData(prevState => ({
            ...prevState,
            odds: newOdds
        }));
     };

      const handleResetBtn = () => {
        // setIsBetSlipOpen(false);
        setBetsData((prev) => ({
            ...prev,
            stake: "0", // Setting stake to '0'
          }));
    }

    const cretaModelFun = () =>{
        return ReactDOM.createPortal(
            <GloblePopup
                  isOpen={isBetSlipOpen}
                  onClose={() => setIsBetSlipOpen(false)}
                  title={t('Bet Slip')}
                  cancelText="Close"
                  className="placebet-modal"
               >
               {getBetSlip()}
               </GloblePopup>,
            document.body);
    }

    const getBetSlip = () => {

          return <div className={`bet-slip-container ${isBetSlipOpen ? 'open' : ''}`}>
                <div>
                   <h4 className="bet-slip-title"> {t('Bet Slip')} </h4>
                </div>
                <div className={`bet-slip-box ${betsData.betType === config.back ? 'back' : 'lay'}`}>
                   <div className="bet-slip">
                      <div className="bet-nation">
                      <span>{betsData.competitionName}</span>
                         <a className="close-bet" onClick={handleResetBtn}>
                            <img src="https://wver.sprintstaticdata.com/v108/static/front/img/close.svg" />
                         </a>
                      </div>
                      <div className="bet-team">
                      <span className="bet-team-name">{betsData.selectionName}</span>
                      <div className="match-result">{t(betsData.marketName)}</div>
                      </div>
                   </div>
                   <div className="bet-amount-box">
                   <div className="bet-input back-border">
                      <input type="text" value={betsData.stake} maxlength="9" placeholder={t("Amount")} className="form-control"
                      onChange={(e) => {
                         let inputValue = e.target.value;
                         if (/^\d*\.?\d*$/.test(inputValue)) {
                            // updateBook(betsData.stake, inputValue);
                            setBetsData((prev) => ({ ...prev, stake: inputValue }));
                         }
                      }}  />
                         </div>
                         <div className="odds-box">
                            <input type="number" value={betsData.isFancy === config.isNotfancy ? betsData.odds : betsData.rate} onChange={()=> ''} readOnly className="form-control" />
                            <span><img src="../images/arrow-down.svg" className="arrow-up" onClick={handleIncrementOdds}/></span>
                            <span><img src="../images/arrow-down.svg" className="arrow-down" onClick={handleDecrementOdds}/></span>
                         </div>
                   </div>
                   <div className="bet-buttons">
                   {Array.isArray(stack) && stack.map((item,index) => (
                      <button key={index} id={`${item}`} className="btn" onClick={()=> addValue(item.value)}><span>{item.key}</span></button>
                               )) }

                   </div>
                   <div className="place-bet-btn">
                      <button className="btn clear" onClick={handleClear}>{t("clear")}</button>
                      <button className="btn" onClick={handlePlceBets}><span>{t('Place bet')}</span></button>
                   </div>
                </div>
                <div className={`inner-loader ${betOnProcess? 'show':''}`}><img src={rip} alt="loder" height={'200px'} width={"200px"}/></div>
             </div>
       }

    const fetchData = (currentTab,selectedTypes) => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };

        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/v1/games/getExchangeData2?type=${currentTab}&filter=${selectedTypes}`,
          requestOptions
        )
          .then(async (response) => {
            let paresData = await response.json();
            console.log(paresData,"paresDataparesDataparesData");
            // sendMessage('exchangedata',{type:isActiveSport});
            setMatchData(paresData);
            if (getSportType()) {
                let list = uniqueCountriesFirst(paresData);
                if (list.length > 0) {
                    setSubActive(list[0]);
                }
            }
          })
          .catch((error) => {
            console.log(error);
          });
    };

    const filterByCountry = (data, countryCode) => {
        if (getSportType()) {
            return data?.game?.flatMap(game =>
                Array.isArray(game.matchData)
                    ? game.matchData.filter(match => match.match?.country === countryCode && (match.match?.sportId == 7 || match.match?.sportId == 4339 ))
                    : []
            ) || [];
        }else{
            return [];
        }
    };

    const handleTabClick = (tab) => {
        setActiveSport(tab)
    };

    const getStyle = (tab, isActiveSport,colors) => {
        if (isActiveSport === tab) {
          // Apply style for active tab
          return {
            background: colors, // Dynamically access the color based on the tab
            color: '#fff'
          };
        }
      };

      const getTab = (tab,colors) => {
        if (isActiveSport === tab) {
          // Apply style for active tab
          return colors
        }
      };

      const getTabHead = () => {
        if (isActiveSport === config.TabCricket) {
          return {
            background: config.ColorCricket,
            color: '#fff'
          };
        } else if (isActiveSport === config.TabVCricket) {
            return {
              background: config.ColorVirtualCricket,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabFootball) {
            return {
              background: config.ColorFootball,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabTennis) {
            return {
              background: config.ColorTenis,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabElection) {
            return {
              background: config.ColorElection,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabKabaddi) {
            return {
              background: config.ColorKabaddi,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabGreyhoundRacing) {
            return {
              background: config.ColorGreyhoundRacing,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabHorseRacing) {
            return {
              background: config.ColorHorseRacing,
              color: '#fff'
            };
        }else{
            return {}
        }
      };

      const getsubTabHead = () => {
        if (isActiveSport === config.TabCricket) {
          return {
            background: config.ColorCricket,
            color: '#fff'
          };
        } else if (isActiveSport === config.TabFootball) {
            return {
              background: config.ColorFootball,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabTennis) {
            return {
              background: config.ColorTenis,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabElection) {
            return {
              background: config.ColorElection,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabKabaddi) {
            return {
              background: config.ColorKabaddi,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabGreyhoundRacing) {
            return {
              background: config.ColorGreyhoundRacing,
              color: '#fff'
            };
        } else if (isActiveSport === config.TabHorseRacing) {
            return {
              background: config.ColorHorseRacing,
              color: '#fff'
            };
        }
      };

      const getsubBorderTabHead = () => {
        const sportColors = {
          [config.TabCricket]: config.ColorCricket,
          [config.TabFootball]: config.ColorFootball,
          [config.TabTennis]: config.ColorTenis,
          [config.TabElection]: config.ColorElection,
          [config.TabKabaddi]: config.ColorKabaddi,
          [config.TabGreyhoundRacing]: config.ColorGreyhoundRacing,
          [config.TabHorseRacing]: config.ColorHorseRacing,
        };

        return sportColors[isActiveSport]
          ? { borderBottom: `1px solid ${sportColors[isActiveSport]}` }
          : {};
      };

      const getSportType = () => {
        if (isActiveSport === config.TabGreyhoundRacing || isActiveSport === config.TabHorseRacing) {
            return true;
        }else{
            return false;
        }
    }


    useEffect(() => {
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
         //  if (wsRef.current && wsRef.current.readyState !== WebSocket.OPEN) {
            console.log("Tab is active again, reconnecting WebSocket...");
            startWebSocket();
         //  }
        }
      });
    }, [])



    const startWebSocket = () => {
        if (matchdatas) {
            const marketIds = matchdatas?.game?.flatMap(game =>
                game.matchData.flatMap(match =>
                    match.matchodd
                        .filter(odd => odd.marketName === "Match Odds") // Filter only "Match Odds"
                        .map(odd => String(odd.marketId)) // Ensure all marketIds are strings
                )
            );

            const ws = new WebSocket(config.wssLink);
            wsRef.current = ws;

            ws.onopen = () => {
              for (let indexMo = 0; indexMo < marketIds?.length; indexMo++) {
                const element = marketIds[indexMo];
                if (!subscribeChannels.current.includes(`${config.Topic_Match_Odds}${element}`)) {
                  ws.send(JSON.stringify({ action: 'subscribe', topic: `${config.Topic_Match_Odds}${element}` }));
                  subscribeChannels.current.push(`${config.Topic_Match_Odds}${element}`);
                }
              }

              heartbeatInterval = setInterval(() => {
                if (ws.readyState === WebSocket.OPEN) {
                  ws.send(JSON.stringify({ action: 'ping' }));
                  // console.log("Pingggggggggg");
                } else if (ws.readyState === WebSocket.CLOSED) {
                  clearInterval(heartbeatInterval);
                  reconnectWebSocket(); // Function to reconnect
                  console.log("reeeeeeeeeeeeeeeeeeeeeeTry");
                }
              }, 10000); // 10 seconds
            };

            ws.onmessage = (event) => {
            //   console.log('parsedData0');
              const { topic, marketData } = JSON.parse(event.data);
              if (marketData) {
                const parsedData = JSON.parse(marketData);
                if (topic.startsWith(`${config.Topic_Match_Odds}`)) {
                     setMatchOdd((prevMOData) => ({
                        ...prevMOData,
                        [`${topic.split('/').pop()}`]: parsedData,
                      }));
                }
              }
            };

            ws.onclose = () => {
              console.log('11111--WebSocket disconnected');
              clearInterval(heartbeatInterval);
              reconnectWebSocket();
            };

            ws.onerror = (error) => {
              console.log('11111--WebSocket error:', error);
              clearInterval(heartbeatInterval);
              reconnectWebSocket();
            };
        }
      };

      const reconnectWebSocket = () => {
        console.log('11111--Reconnecting WebSocket...');
        setTimeout(() => {

          startWebSocket();
        }, 3000); // Reconnect after 3 seconds
      };

      const unsubscribeAll = () => {
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
          subscribeChannels.current.forEach((topic) => {
            wsRef.current.send(JSON.stringify({ action: 'unsubscribe', topic }));
          });
          subscribeChannels.current = [];
        }
      };

    const formatDate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[d.getMonth()];  // Get the abbreviated month name

        return `${day} ${month}`;
      };

      const formatTime = (date) => {
        const d = new Date(date);
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
      };

    const validation = (price) => {
        if(price &&
            price !== '-' &&
            price !== 0 &&
            price <= 1000.00){
                return true
            }else{
                return false
            }
    }
    const getActiveSportTitle = (isActiveSport) =>{
        if (isActiveSport === config.TabCricket) {
            return t('Cricket')
        }else if(isActiveSport === config.TabElection){
            return t('Politics')
        }else if(isActiveSport === config.TabFootball){
            return t('Football')
        }else if(isActiveSport === config.TabGreyhoundRacing){
            return t('Greyhound Racing')
        }else if (isActiveSport === config.TabHorseRacing) {
            return t('Horse Racing')
        }else if (isActiveSport === config.TabKabaddi) {
            return t('Kabaddi')
        }else if (isActiveSport === config.TabTennis) {
            return t('Tennis')
        }else if (isActiveSport === config.TabVCricket) {
            return t('Cricket')
        }
    }
    const getIcon = () =>{
        if (isActiveSport === config.TabCricket) {
            return <i className="d-icon icon-4"></i>
        }else if (isActiveSport === config.TabVCricket) {
            return <><i className="icon-998 d-icon"></i> <span className="ml-1">+</span> <i className="icon-suits d-icon ml-1"></i></>
        }else if (isActiveSport === config.TabFootball) {
            return <i className="d-icon icon-1"></i>
        }else if (isActiveSport === config.TabTennis) {
            return <i className="d-icon icon-2"></i>
        }else if (isActiveSport === config.TabElection) {
            return <i className="d-icon icon-40"></i>
        }else if (isActiveSport === config.TabKabaddi) {
            return <i className="d-icon icon-66"></i>
        }else if (isActiveSport === config.TabGreyhoundRacing) {
            return <i className="d-icon icon-65"></i>
        }else if (isActiveSport === config.TabHorseRacing) {
            return <i className="d-icon icon-10"></i>
        }
    }

    const uniqueCountries = matchdatas && matchdatas.game?.some(game => game?.matchData?.length > 0)
    ? [...new Set(matchdatas.game.flatMap(game => game.matchData.map(item => item.match.country)))]
    : [];

    const handleClick = (country) => {
        setSubActive(country);
        console.log(country,"countrycountry");
    }


    const getLock = () => {
        // <img src='../images/lock.svg' alt='as'/>
        return <i className="fa fa-lock" style={{pointerEvents:'none'}}></i>
    }

    const checkLock = (price,status,id) =>{
        // console.log(price,status,id?.marketId,"checkLockcheckLockcheckLock");

        if (isAdminSuspended(id?.marketId)) {
            if(!validation(price)){
                return true;
            }else{
                return false;
            }
        }else{
            return true;
        }

    }



    const betplace = (odds,runner,eventId,matchOdds,betType,match) => {
        if (sessionStorage.getItem('loggedIn') || loggedIn) {
            config.DATA = {
                eventId: eventId,
                marketId: matchOdds.marketId,
                stake: '0',
                betType: betType,
                selectionName: runner.runnerName,
                odds: odds,
                competitionName : match.competitionName,
                marketData:'',
                marketType:'',
                secId: `${runner.runnerId}`,
                isCashout: false,
                isFancy:config.isNotfancy
            }
            setBetsData({
                eventId: eventId,
                marketId: matchOdds.marketId,
                stake: '0',
                betType: betType,
                selectionName: runner.runnerName,
                odds: odds,
                competitionName : match.competitionName,
                marketData:'',
                marketType: '',
                secId: `${runner.runnerId}`,
                isCashout: false,
                isFancy:config.isNotfancy
            });
            setIsBetSlipOpen(true);
        }else{
            setLoginPop(true);
        }

    }

    const getMatchOdds = (matchdata) =>{
        const marketId = matchdata.matchodd.find(odd => odd.marketName === "Match Odds")?.marketId || null;
        if (marketId && matchOdd) {
            if (matchOdd[marketId]) {
                return matchOdd[marketId]
                console.log(matchOdd[marketId],"matchOdd[marketId]matchOdd[marketId]");
            }else{
                return matchdata.matchodd[0];
            }
        }else{
            return matchdata.matchodd[0];
        }
    }

    const validationBM = (price) => {
        if (price &&
           price != '-' &&
           price != 0) {
           return true
        } else {
           return false
        }
     }


    return (
        <>
            <div className="betlist-wraper">
            <div className="bet-tab menu-link">
                    <Swiper
                        slidesPerView={4}
                        autoplay={false}
                        modules={[Autoplay]}
                        className="mySwiper"
                    >
                        <SwiperSlide> <Link className="sport-tab-btn aviator-menu-icon" to="/live_casinoInPlay/67aeeedb94d27319c10f17f4"><AviatorIcon /></Link>  </SwiperSlide>

                        {/* <SwiperSlide> <Link className={`sport-tab-btn ${activeMenu === "/lottry" ? 'active' : ''}`} to="/lottry">Lottery</Link> </SwiperSlide> */}
                        {/* {sessionStorage.getItem('loggedIn') || loggedIn ? <SwiperSlide> <Link className={`sport-tab-btn ${activeMenu === "/sportbook" ? 'active' : ''}`} to="/sportbook">SportBook</Link>  </SwiperSlide>:''} */}
                        <SwiperSlide> <Link className={`sport-tab-btn ${activeMenu === "/sport" ? 'active' : ''}`} to="/sport">{t('Exchange')}</Link>  </SwiperSlide>
                        <SwiperSlide><Link className={`sport-tab-btn ${activeMenu === "/casino" ? 'active' : ''}`} to="/casino">{t('Live Casino')}</Link>  </SwiperSlide>
                        <SwiperSlide> <Link className={`sport-tab-btn ${activeMenu === "/slots" ? 'active' : ''}`} to="/slots">{t('Slot')}</Link></SwiperSlide>
                        <SwiperSlide> <Link className={`sport-tab-btn ${activeMenu === "/fantasygames" ? 'active' : ''}`} to="/fantasygames">{t('Fantasy Games')}</Link></SwiperSlide>
                    </Swiper>
                </div>
                <div className="bet-tab">
                    <Swiper
                        slidesPerView={'auto'}
                        navigation={true}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        modules={[Autoplay, Navigation]}
                        className="mySwiper"
                    >

                        <SwiperSlide style={{ width: 'auto' }} >
                            <button className={`sport-tab-btn ${isActiveSport === config.TabCricket ? 'active' : ''}`}
                                onClick={() => handleTabClick(config.TabCricket)} style={getStyle(config.TabCricket, isActiveSport, config.ColorCricket)}><div className='icon-graper'><i className="d-icon icon-4"></i> </div> <span>{t('Cricket')}</span> </button>
                        </SwiperSlide>
                        <SwiperSlide style={{ width: 'auto' }} >
                            <button className={`sport-tab-btn ${isActiveSport === config.TabVCricket ? 'active' : ''}`}
                                onClick={() => handleTabClick(config.TabVCricket)} style={getStyle(config.TabVCricket, isActiveSport, config.ColorVirtualCricket)}><div className='icon-graper'><i class="icon-998 d-icon"></i> + <i class="icon-suits d-icon"></i></div> <span>{t('Cricket')}</span> </button>
                        </SwiperSlide>
                        <SwiperSlide style={{ width: 'auto' }}>
                            <button className={`sport-tab-btn ${isActiveSport === config.TabFootball ? 'active' : ''}`}
                                onClick={() => handleTabClick(config.TabFootball)} style={getStyle(config.TabFootball, isActiveSport, config.ColorFootball)}><div className='icon-graper'><i className="d-icon icon-1"></i></div> <span>{t('Football')}</span></button>
                        </SwiperSlide>
                        <SwiperSlide style={{ width: 'auto' }}>
                            <button className={`sport-tab-btn ${isActiveSport === config.TabTennis ? 'active' : ''}`}
                                onClick={() => handleTabClick(config.TabTennis)} style={getStyle(config.TabTennis, isActiveSport, config.ColorTenis)}><div className='icon-graper'><i className="d-icon icon-2"></i></div> <span>{t('Tennis')}</span></button>
                        </SwiperSlide>
                        <SwiperSlide style={{ width: 'auto' }}>
                            <button className={`sport-tab-btn ${isActiveSport === config.TabElection ? 'active' : ''}`}
                                onClick={() => handleTabClick(config.TabElection)} style={getStyle(config.TabElection, isActiveSport, config.ColorElection)}><div className='icon-graper'><i className="d-icon icon-40"></i></div> <span>{t("Politics")}</span></button>
                                </SwiperSlide>
                        <SwiperSlide style={{ width: 'auto' }}>
                            <button className={`sport-tab-btn ${isActiveSport === config.TabKabaddi ? 'active' : ''}`}
                            onClick={() => handleTabClick(config.TabKabaddi)} style={getStyle(config.TabKabaddi, isActiveSport, config.ColorKabaddi)}><div className='icon-graper'><i className="d-icon icon-66"></i></div> <span>{t('Kabaddi')}</span></button>
                     </SwiperSlide>
                        <SwiperSlide style={{ width: 'auto' }}>
                            <button className={`sport-tab-btn ${isActiveSport === config.TabHorseRacing ? 'active' : ''}`}
                                onClick={() => handleTabClick(config.TabHorseRacing)} style={getStyle(config.TabHorseRacing, isActiveSport, config.ColorHorseRacing)}><div className='icon-graper'><i className="d-icon icon-10"></i></div> <span>{t('Horse Racing')}</span></button>
                        </SwiperSlide>
                        <SwiperSlide style={{ width: 'auto' }}>
                            <button className={`sport-tab-btn ${isActiveSport === config.TabGreyhoundRacing ? 'active' : ''}`}
                                onClick={() => handleTabClick(config.TabGreyhoundRacing)} style={getStyle(config.TabGreyhoundRacing, isActiveSport, config.ColorGreyhoundRacing)}><div className='icon-graper'><i className="d-icon icon-65"></i></div> <span>{t('Greyhound Racing')}</span></button>
                        </SwiperSlide>
                    </Swiper>
                </div>
                {!getSportType() &&
                <div className="tab-content">
                    <div className="tab-panel">

                            <div className="betlist-header" style={getTabHead()}>
                                <div className="betlist-col">
                                    <div className="sport-title" style={{textTransform:"capitalize"}}>
                                        {getIcon()} { getActiveSportTitle(isActiveSport)}
                                    </div>
                                </div>
                                <div className="betlist-col odds-col">
                                    <div className="odds-title">
                                        <div className="box">1 </div>
                                        <div className="box">X</div>
                                        <div className="box">2</div>
                                    </div>
                                </div>
                            </div>
                            <div className="betlist">

                            {matchdatas && matchdatas.game?.some(game => game?.matchData?.length > 0) ? (
                                matchdatas.game.map((game, gameIndex) =>
                                    game?.matchData?.length > 0 ? (
                                        game.matchData.map((matchdata, matchIndex) => (
                                        <div className="betlist-row" id={matchdata.match.eventId} style={{cursor:"pointer"}} key={`${gameIndex}-${matchIndex}`}>
                                            <div className="betlist-col" onClick={() => navigate(`/exchange_inPlay/${matchdata.match.eventId}`)}>
                                                <div className="match-info">
                                                    <div className={`game-date ${matchdata.match.status === "IN_PLAY"? 'inplay':'' }`}>
                                                        {matchdata.match.status === "IN_PLAY"? <span>{config.Live}</span>:<><p className="day text-left">{formatDate(matchdata.match.openDate)}</p> <p className="mb-0 day text-left">{formatTime(matchdata.match.openDate)}</p></>}
                                                    </div>
                                                    <div className="match-name">
                                                        <p className="team-name">{matchdata.match.eventName}</p>
                                                        <p className="team-event"> ({matchdata.match.competitionName}) </p>
                                                    </div>
                                                    <div className="game-icons">
                                                        <div className="game-icon">{matchdata.MatchOddCount > 0 ? <span className="f-bm-icon">M</span> :'' }</div>
                                                        <div className="game-icon">{matchdata.BMcount > 0 ? <span className="f-bm-icon">BM</span> :'' }</div>
                                                        <div className="game-icon">{matchdata.FANCYcount > 0 ? <span className="f-bm-icon">f</span> :'' }</div>
                                                        <div className="game-icon">{matchdata.TossCount > 0 ? <span className="f-bm-icon">T</span> :'' }</div>
                                                        <div className="game-icon">{matchdata.match.status === 'IN_PLAY' ? <i className="icon-tv d-icon"></i> :''}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="betlist-col odds-col">
                                                <div className="match-odds">

                                                    <div className={`box ${checkLock(getMatchOdds(matchdata)?.runners[0]?.backPrices[0]?.price,matchdata.match.status,getMatchOdds(matchdata)) ? 'lock':''}`}>
                                                    {getMatchOdds(matchdata)?.runners ?
                                                    <BackPricesBoxPerticular
                                                        runner={getMatchOdds(matchdata)?.runners}
                                                        runnerposition={0}
                                                        position={0}
                                                        handleOnBackClick={()=>betplace(getMatchOdds(matchdata)?.runners[0]?.backPrices[0]?.price,getMatchOdds(matchdata)?.runners[0],matchdata.match.eventId,getMatchOdds(matchdata),config.back,matchdata.match)}
                                                        getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                            </>
                                                         )}
                                                    />:<span className='back lock'> — </span> }

                                                {getMatchOdds(matchdata)?.runners ?
                                                    <LayPricesBoxPerticular
                                                        runner={getMatchOdds(matchdata)?.runners}
                                                        runnerposition={0}
                                                        position={0}
                                                        handleOnBackClick={()=>betplace(getMatchOdds(matchdata)?.runners[0]?.layPrices[0]?.price,getMatchOdds(matchdata)?.runners[0],matchdata.match.eventId,getMatchOdds(matchdata),config.lay,matchdata.match)}
                                                        getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                            </>
                                                         )}
                                                    />:<span className='lay lock'> — </span> }
                                                    </div>

                                                    {matchdata.match.sportId == '1' ?
                                                    <div className={`box ${checkLock(getMatchOdds(matchdata)?.runners[2]?.backPrices[0]?.price,matchdata.match.status,getMatchOdds(matchdata)) ? 'lock':''}`}>
                                                    {getMatchOdds(matchdata)?.runners ?
                                                    <BackPricesBoxPerticular
                                                        runner={getMatchOdds(matchdata)?.runners}
                                                        runnerposition={2}
                                                        position={0}
                                                        handleOnBackClick={()=>betplace(getMatchOdds(matchdata)?.runners[2]?.backPrices[0]?.price,getMatchOdds(matchdata)?.runners[2],matchdata.match.eventId,getMatchOdds(matchdata),config.back,matchdata.match)}
                                                        getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                            </>
                                                         )}
                                                    />:<span className='back lock'> — </span> }

                                                {getMatchOdds(matchdata)?.runners ?
                                                    <LayPricesBoxPerticular
                                                        runner={getMatchOdds(matchdata)?.runners}
                                                        runnerposition={2}
                                                        position={0}
                                                        handleOnBackClick={()=>betplace(getMatchOdds(matchdata)?.runners[2]?.layPrices[0]?.price,getMatchOdds(matchdata)?.runners[2],matchdata.match.eventId,getMatchOdds(matchdata),config.lay,matchdata.match)}
                                                        getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                            </>
                                                         )}
                                                    />:<span className='lay lock'> — </span> }
                                                    </div>
                                                    :<div className="box">
                                                        <span className='no-value'>—</span>
                                                        <span className='no-value'>—</span>
                                                    </div>}

                                                    <div className={`box ${checkLock(getMatchOdds(matchdata)?.runners[1]?.backPrices[0]?.price,matchdata.match.status,getMatchOdds(matchdata)) ? 'lock':''}`}>

                                                    {getMatchOdds(matchdata)?.runners ?
                                                    <BackPricesBoxPerticular
                                                        runner={getMatchOdds(matchdata)?.runners}
                                                        runnerposition={1}
                                                        position={0}
                                                        handleOnBackClick={()=>betplace(getMatchOdds(matchdata)?.runners[1]?.backPrices[0]?.price,getMatchOdds(matchdata)?.runners[1],matchdata.match.eventId,getMatchOdds(matchdata),config.back,matchdata.match)}
                                                        getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                            </>
                                                         )}
                                                    />:<span className='back lock'> — </span> }

                                                {getMatchOdds(matchdata)?.runners ?
                                                    <LayPricesBoxPerticular
                                                        runner={getMatchOdds(matchdata)?.runners}
                                                        runnerposition={1}
                                                        position={0}
                                                        handleOnBackClick={()=>betplace(getMatchOdds(matchdata)?.runners[1]?.layPrices[0]?.price,getMatchOdds(matchdata)?.runners[1],matchdata.match.eventId,getMatchOdds(matchdata),config.lay,matchdata.match)}
                                                        getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                            </>
                                                         )}
                                                    />:<span className='lay lock'> — </span> }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    ) : null
                                )
                            ) : (
                                <div className="no-matches-found">{t('NoLiveEvents')}</div>
                            )}
                            </div>
                    </div>
                </div>}

                {getSportType() &&
                    <div className="tab-content">
                                    <div className="tab-panel">
                                            <div className="betlist-header" style={getTabHead()}>
                                                <div className="betlist-col">
                                                    <div className="sport-title" style={{textTransform:"capitalize"}}>
                                                        {getIcon()} {getActiveSportTitle(isActiveSport)}
                                                    </div>
                                                </div>
                                                <div className="betlist-col odds-col">
                                                    <div className="odds-title">

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-btns" style={getsubBorderTabHead()}>
                                                <ul>
                                                {matchdatas && matchdatas.game?.some(game => game?.matchData?.length > 0) ? (
                                                    matchdatas && uniqueCountries && uniqueCountries.length > 0 && uniqueCountries.map((country, index) => (
                                                        <li key={index}><span className={`hourse-link ${subActive === country ? 'active' :''}`} style={subActive === country ? getsubTabHead():{}} onClick={()=>handleClick(country)}><span>{country}</span>{" "}</span></li>
                                                    ))) : ('')}
                                                </ul>
                                            </div>
                                            <div className="betlist hourserascing">

                                            {filterByCountry(matchdatas, subActive).length > 0 ? (
                                                filterByCountry(matchdatas, subActive).map((matchdata, index) => (
                                                        <div className="betlist-row" key={index} style={{cursor:"pointer"}} >
                                                            <div className="betlist-col">
                                                                <div className="match-info">
                                                                    <div className="match-name">
                                                                     <p className="team-name"><i className="icon-tv d-icon"></i> {matchdata.match.eventName}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="betlist-col odds-col">
                                                                <div className="match-odds">

                                                                {matchdata.HRGHMO.map((market,marketIndex)=>{
                                                                    let date = new Date(market.marketTime);
                                                                    let isShow = false
                                                                    if(date.getTime() - (1000 * 60 * 15) <= Date.now()){
                                                                        isShow = true
                                                                    }
                                                                    date.setHours(date.getHours() + 5);
                                                                    date.setMinutes(date.getMinutes() + 30);
                                                                    let hours = date.getUTCHours();
                                                                    let minutes = date.getUTCMinutes();
                                                                    let formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
                                                                    return (
                                                                        isShow ?
                                                                        <div className="box">
                                                                                <Link to={`/exchange_inPlay/${matchdata.match.eventId}/${market.marketId}`} key={marketIndex} id={market.marketId}>
                                                                                    <span
                                                                                        key={market.marketId}
                                                                                        className={`no-value odds-tag live`}
                                                                                        id={market.marketId}
                                                                                    >
                                                                                    {formattedTime}
                                                                                    </span>
                                                                                </Link>
                                                                                </div>
                                                                            :
                                                                            <div className="box">
                                                                            <span
                                                                                key={marketIndex}
                                                                                className={`no-value odds-tag`}
                                                                                id={market.marketId}
                                                                                >
                                                                                {formattedTime}
                                                                            </span>
                                                                            </div>
                                                                    );
                                                                })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))):('')}
                                            </div>
                                    </div>
                                </div>
                }
            </div>
            {cretaModelFun()}

        </>
    )
}
export default BetList